import {useTranslation} from "react-i18next";
import React, {useCallback, useState} from "react";
import Api, {API_ERROR} from "../../service/api";
import {Alert} from "../alert";
import {useToasts} from "react-toast-notifications";
import {ButtonSecondary} from "../button";
import {ModalTopUp} from "./modal.topup";
import {useDispatch} from "react-redux";
import {SettingsAction} from "../../redux/reducers/settings";
import {UserAction} from "../../redux/reducers/user";
import {useAppSelector} from "../../redux/store";
import {IconMembership} from "../icons";
import {ContentContainer, DetailContainer, DetailLabel, DetailValue} from "./modal.withdraw";
import {ModalInfo} from "./modal.info";
import {Loader} from "../loader";
import {SubmitButton} from "../form/formgen2";
import styled from "styled-components";

const MODAL_WIDTH = '460px'

const SubscriptionErrorCont = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 8px;
`

export const ModalSubscriptionRenew = ({teamId, subscriptionTitle, subscriptionPrice, onConfirm, ...rest}) => {
    const {t} = useTranslation();
    const {settings} = useAppSelector()
    const { addToast } = useToasts()
    const [isLoading, setIsLoading] = useState(false);

    /*const fakeError = {
        message: "Error Test Fuf Error Test Fuf Error Test Fuf",
        code: API_ERROR.NOT_ENOUGH_FUNDS
    }*/

    const [error, setError] = useState(false);
    const [isTopUpModalVisible, setTopUpModalVisible] = useState(false)
    const dispatch = useDispatch()

    const _onConfirm = useCallback(async ()=>{
        setIsLoading(true);
        setError(false);
        try{
            let result = await Api.paymentRenewSubscription(teamId);

            dispatch(UserAction.loadUserInfo());

            addToast(t(`modal.subscriptionrenew.renewal_success`, {endDate: result?.subscription?.date_end}), {
                appearance: 'success',
                autoDismiss: true,
            })
            onConfirm && onConfirm();
        }catch(e){
            setError(e);
            console.log(`paymentRenewSubscription Error `, e);
        }
        setIsLoading(false);
    }, [onConfirm])

    return (
      <>
          <ModalInfo
            {...rest}
            isModal={true}
            width={MODAL_WIDTH}
            maxWidth={`max-w-xs sm:max-w-lg md:max-w-xl lg:max-w-2xl`}
            icon={<IconMembership size={20} />}
            title={t('modal.subscriptionrenew.title')}
            body={
                <>
                    {error &&
                      <SubscriptionErrorCont>
                          <Alert
                            color="bg-transparent border-red-500 text-red-500 mb-2"
                            borderLeft
                            raised>
                              {error?.message || `Unknown error`}

                              {error?.code === API_ERROR.NOT_ENOUGH_FUNDS &&
                                <div style={{marginTop: '8px'}}>
                                    <ButtonSecondary onClick={()=>setTopUpModalVisible(true)}>
                                        {t(`modal.subscriptionrenew.button_topup`)}
                                    </ButtonSecondary>
                                    <ModalTopUp
                                      isOpen={isTopUpModalVisible}
                                      onCancel={()=>setTopUpModalVisible(false)}
                                    />
                                </div>}
                          </Alert>
                      </SubscriptionErrorCont>}

                    <ContentContainer>
                        <DetailContainer>
                            <DetailLabel>{t(`form.field.subscription`)}</DetailLabel>
                            <DetailValue>{subscriptionTitle}</DetailValue>
                        </DetailContainer>

                        {settings.monetization_active && <DetailContainer>
                            <DetailLabel>{t(`form.field.price`)}</DetailLabel>
                            <DetailValue>${subscriptionPrice}</DetailValue>
                        </DetailContainer>}

                        <DetailContainer>
                            <DetailLabel>{t(`form.field.period.title`)}</DetailLabel>
                            <DetailValue>{t('modal.subscriptionrenew.period.1month')}</DetailValue>
                        </DetailContainer>
                    </ContentContainer>

                    {
                        isLoading ? <Loader show={true} className={"mb-4"} /> :
                          <SubmitButton
                            as='input'
                            type="submit"
                            value={t('modal.subscriptionrenew.button_confirm')}
                            style={{width: '100%'}}
                            onClick={_onConfirm}
                          />
                    }
                </>
            }
          />
      </>
    )
}
